module.exports = __webpack_public_path__ + "static/media/System_Boundary-insulation.769c6539.png";